
'use strict';

//Require Modules
var $ = require('jquery'),
  Backbone = require('backbone'),
  _ = require('underscore'),
  config = require('../config'),
  utilities = require('../utilities'),
  //logger = require('loglevel'),
  mediator = require('../mediator');

Backbone.$ = $;

var SessionController = Backbone.View.extend({

  // collection: should be a projects collection
  initialize: function(options) {
    options = options || {};
    this.mediator = options.mediator || mediator;
    this.bindMediatorEvents();
  },

  bindMediatorEvents: function() {
    this.mediator.on(config.events.session.checkLoggedInState, this.checkLoggedInState, this);
    this.mediator.on(config.events.session.unauthorizedResponseReceived, this.unauthorizedResponseReceived, this);
  },

  // null = we don't know
  // false = we've received a 401 from some call
  // true = yes ... as far as we know
  isLoggedIn: function() {
    return this.model.get('loggedIn');
  },

  checkLoggedInState: function() {
    this.model.set({ checkingLoggedInState: true });
    $.ajax({
      url: config.urls.authorized.api,
      handleErrorLocally: true,
      data: utilities.addCustIpToDataObject({}),
      success: _.bind(function() {
        this.model.set({
          checkingLoggedInState: false,
          loggedIn: true
        });
        this.mediator.trigger(config.events.session.loggedInStateChecked, this.model.toJSON());
      }, this),
      error: _.bind(function() {
        this.model.set({
          checkingLoggedInState: false,
          loggedIn: false
        });
        this.mediator.trigger(config.events.session.loggedInStateChecked, this.model.toJSON());
      }, this)
    });
  },

  unauthorizedResponseReceived: function() {
    this.model.set({
      loggedIn: false
    });
  }

});

module.exports = SessionController;



// WEBPACK FOOTER //
// ./assets/js/session/sessionController.js